import { render, staticRenderFns } from "./KpiNumberOfAlerts.vue?vue&type=template&id=8347351e&"
import script from "./KpiNumberOfAlerts.vue?vue&type=script&lang=js&"
export * from "./KpiNumberOfAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports